export default __webpack_public_path__ + "images/RQ.5323676.png";